"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WartaAndActivities() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const footer = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const newsItems = [{
    title: "Konsolidasi Nasional Pemuda Pancasila",
    category: "Warta Berita",
    date: "2024",
    status: "TERVERIFIKASI",
    duration: "LAPORAN",
    synopsis: "Langkah strategis organisasi dalam memperkuat basis massa dan sinergi antar wilayah di seluruh Indonesia.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_konsolidasi.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_konsolidasi.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_konsolidasi.png-wvc-sizes",
    highlight: true
  }, {
    title: "Aksi Sosial Tanggap Bencana",
    category: "Kegiatan Aksi",
    date: "2024",
    status: "TERVERIFIKASI",
    duration: "LAPORAN",
    synopsis: "Gerakan cepat unit fungsional dalam memberikan bantuan kemanusiaan bagi masyarakat terdampak bencana alam.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_aksi_sosial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_aksi_sosial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_aksi_sosial.png-wvc-sizes",
    highlight: false
  }, {
    title: "Pelantikan Pengurus Wilayah Baru",
    category: "Struktur Hierarki",
    date: "2024",
    status: "TERVERIFIKASI",
    duration: "LAPORAN",
    synopsis: "Peresmian kepengurusan baru untuk memperkuat komando dan mandat organisasi di tingkat daerah.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_pelantikan.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_pelantikan.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_pelantikan.png-wvc-sizes",
    highlight: true
  }, {
    title: "Seminar Konstitusi Organisasi",
    category: "Profil Konstitusi",
    date: "2024",
    status: "TERVERIFIKASI",
    duration: "LAPORAN",
    synopsis: "Pendalaman nilai-nilai dasar dan konstitusi bagi seluruh kader untuk menjaga marwah organisasi.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_seminar.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_seminar.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/warta_seminar.webp-wvc-sizes",
    highlight: false
  }];
  return <section data-section-id="4641" id="wartaandactivities" className="bg-white text-black relative overflow-hidden py-24 md:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div ref={header.ref} className={`grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-7">
            <div className="font-default text-[11px] uppercase tracking-[0.3em] text-orange-600 mb-8">
              02 / Warta Terkini
            </div>
            <h2 className="font-default text-5xl leading-[1.05] tracking-tight md:text-7xl">
              Warta & <span className="italic text-orange-600">Aktivitas</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:pt-4">
            <p className="font-default text-base leading-relaxed text-gray-600 md:text-[15px]">
              Setiap laporan dan kegiatan yang kami sajikan merupakan cerminan dari dedikasi organisasi dalam mengawal mandat serta memberikan pelayanan terbaik bagi masyarakat dan bangsa.
            </p>
            <div className="mt-6 h-px w-24 bg-orange-600/40" />
          </div>
        </div>

        {}
        <div className="mt-20 grid grid-cols-1 gap-x-10 gap-y-16 md:mt-28 md:grid-cols-2 md:gap-x-16 md:gap-y-24">
          {newsItems.map((item, i) => {
          const isOffset = i % 2 === 1;
          return <NewsCard key={item.title} data-index={i} item={item} offsetClass={isOffset ? "md:mt-16 lg:mt-32" : ""} />;
        })}
        </div>

        {}
        <div ref={footer.ref} className={`mt-24 flex justify-center md:mt-32 transition-all duration-1000 ease-out ${footer.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Link to="/News2Page" className="group inline-flex items-center gap-3 font-default text-[11px] uppercase tracking-[0.3em] text-black transition-colors hover:text-orange-600">
            <span className="relative">
              Lihat Semua Warta
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-orange-600 transition-all duration-500 group-hover:w-full" />
            </span>
            <ArrowRight className="size-3.5 transition-transform duration-500 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>;
}
type NewsCardProps = {
  item: {
    title: string;
    category: string;
    date: string;
    status: string;
    duration: string;
    synopsis: string;
    image: string;
    srcset: string;
    sizes: string;
    highlight: boolean;
  };
  offsetClass?: string;
  "data-index"?: number;
};
function NewsCard({
  item,
  offsetClass = "",
  ...rest
}: NewsCardProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} data-index={rest["data-index"]} className={`group ${offsetClass} transition-all duration-[1100ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      {}
      <div className="relative overflow-hidden">
        <div className="relative aspect-[2/3] overflow-hidden bg-gray-100">
          <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.title} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-all duration-[800ms] ease-out group-hover:scale-[1.04]" />

          {}
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.18] mix-blend-overlay" style={{
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='g'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23g)'/></svg>\")"
        }} />

          {}
          <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
          background: "radial-gradient(ellipse at center, transparent 50%, rgba(0,0,0,0.4) 100%)"
        }} />

          {}
          <div aria-hidden="true" className="pointer-events-none absolute inset-3 border border-orange-600/0 transition-all duration-700 group-hover:inset-2 group-hover:border-orange-600/70" />

          {}
          {item.highlight && <div className="absolute right-4 top-4 z-10">
              <div className="bg-orange-600 px-2.5 py-1 font-default text-[9px] uppercase tracking-[0.25em] text-white">
                Penting
              </div>
            </div>}
        </div>
      </div>

      {}
      <div className="mt-6 font-default text-[10px] uppercase tracking-[0.3em] text-gray-500">
        {item.date} <span className="mx-1.5 text-orange-600/60">·</span>{" "}
        {item.category}{" "}
        <span className="mx-1.5 text-orange-600/60">·</span> {item.duration}
      </div>

      {}
      <h3 className="font-default mt-4 text-3xl leading-[1.1] tracking-tight md:text-4xl">
        {item.title}
      </h3>

      {}
      <p className="font-default mt-4 max-w-md text-sm leading-relaxed text-gray-600">
        {item.synopsis}
      </p>

      {}
      <div className="mt-6">
        <Button asChild variant="outline" className="h-11 border-orange-600/40 bg-transparent px-6 font-default text-[10px] uppercase tracking-[0.3em] text-black hover:bg-orange-600 hover:text-white hover:border-orange-600">
          <Link to="/News2Page">
            Baca Selengkapnya
            <ArrowRight className="ml-1 size-3.5" />
          </Link>
        </Button>
      </div>
    </div>;
}